const TABLE_TITLE = {
  number: 'Job No.',
  title: 'Title',
  type: 'Type',
  status: 'Status',
  client: 'Client Name',
  division: 'Division',
  acc_executive: 'Acc Executive',
  acc_director: 'Acc Director',
  total_value: 'Total Value',
  budget_used: '% Budget Used', 
  total_invoiced: 'Total Invoiced',
  value_billed: '% Value Billed',
  traffic_used: '% Traffic Used'
};

const NUMERICAL_REG = /^([1-9]\d*)$/;
const HOUR_REG = /^([1-9]\d*(h|hour|hours|\.))$/;
const MINUTE_REG = /^([1-9]\d*(m|mins|min))$/;
const HOUR_MINUTE_REG = /^([1-9]\d*h)([1-5]?\dm)|([1-9]\d*(hour|hours))([1-5]?\d(mins|min))$/;
const HOUR_ALL_REG = /^([0-9]\d*):([0-5][0-9])|([0-9]\d*).([0-9]|[0-9][0-9])$/;

const TIME_REG = /^([1-9]|0[1-9]|1[0-9]|2[0-4])$/;
const TIME_SUFFIX_REG = /^(([1-9]|0[1-9]|1[0-9]|2[0-4])(\.|:))$/;
const TIME_A_REG =  /^(([1-9]|0[1-9]|1[0-2])(a|p))$/;
const TIME_AM_REG =  /^(([1-9]|0[1-9]|1[0-2])(a|p)m)$/;
const TIME_ALL_REG = /^(([1-9]|0[0-9]|1[0-9]|2[0-4])(\.|:)([0-5][0-9]|[0-9]))$/;
const TIME_ALL_A_REG = /^(([1-9]|0[0-9]|1[0-2])(\.|:)([0-5][0-9]|[0-9])(a|p))$/;
const TIME_ALL_AM_REG = /^(([1-9]|0[0-9]|1[0-2])(\.|:)([0-5][0-9]|[0-9])(a|p)m)$/;

const global_config = {
  table_title: TABLE_TITLE,
  numerical_reg: NUMERICAL_REG,
  hour_reg: HOUR_REG,
  minute_reg: MINUTE_REG,
  hour_minute_reg: HOUR_MINUTE_REG,
  hour_all_reg: HOUR_ALL_REG,
  time_reg: TIME_REG,
  time_suffix_reg: TIME_SUFFIX_REG,
  time_a_reg: TIME_A_REG,
  time_am_reg: TIME_AM_REG,
  time_all_reg: TIME_ALL_REG,
  time_all_a_reg: TIME_ALL_A_REG,
  time_all_am_reg: TIME_ALL_AM_REG,
  countPerpage: 100,
  pageOptions: [10, 20, 50, 100],
  status_active_type: 2,
  status_completed_type: 3,
  status_completed_group: 4,
  task_incomplete: 'incompleted',
  task_completed: 'completed',
  job_status_group_nomal: [0, 1, 2],
  public_holiday_type: 5,
  time_zone_keys: ['POSIX', 'ETC'],
  doughnut_chart_colors: {
    billable: '#81CC00',
    non_billable: '#605AF6',
    notLogged: '#F45252',
    upcoming: 'rgba(25, 42, 62, 0.3)',
  },
  head_kv: [
    {
      text: TABLE_TITLE.number,
      value: 'code',
      type: 'text',
      showable: true, // column
      searchable: true, // search icon
      divider: false,
    },
    {
      text: TABLE_TITLE.title, 
      value: 'short',
      type: 'text',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: TABLE_TITLE.type, 
      value: 'job_type',
      type: 'text',
      showable: false,
      searchable: true,
      divider: false,
    },
    {
      text: TABLE_TITLE.status,
      value: 'status',
      type: 'text',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: TABLE_TITLE.client,
      value: 'client',
      type: 'text',
      showable: false,
      searchable: true,
      divider: false,
    },
    {
      text: TABLE_TITLE.division,
      value: 'division',
      type: 'text',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: TABLE_TITLE.acc_executive,
      value: 'acc_exec',
      type: 'text',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: TABLE_TITLE.acc_director,
      value: 'acc_dir',
      type: 'text',
      showable: false,
      searchable: true,
      divider: false,
    },
    {
      text: TABLE_TITLE.total_value,
      value: 'total_value',
      type: 'number',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: TABLE_TITLE.budget_used,
      value: 'perc_quoted_billed',
      type: 'perc',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: TABLE_TITLE.total_invoiced,
      value: 'total_invoiced',
      type: 'number',
      showable: false,
      searchable: false,
      divider: false,
    },
    {
      text: TABLE_TITLE.value_billed,
      value: 'perc_value_billed',
      type: 'perc',
      showable: false,
      searchable: false,
      divider: false,
    },
    {
      text: TABLE_TITLE.traffic_used,
      value: 'perc_traffic_used',
      type: 'perc',
      showable: false,
      searchable: false,
      divider: false,
    },
  ],
  search_type: [
    {
      value: 'short',
      text: 'Job title'
    },
    {
      value: 'statusses',
      text: 'Job status'
    },
    // {
    // 	value: 'client',
    // 	text: 'Client name'
    // },
    // {
    // 	value: 'keyword',
    // 	text: 'Keyword'
    // },
    // {
    // 	value: 'info',
    // 	text: 'in Notes or Specification'
    // },
  ],
  receipts_head: [
    {
      text: '',
      value: 'select',
      type: 'option',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Date', 
      value: 'date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Currency', 
      value: 'currency',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Amount', 
      value: 'value',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'GST', 
      value: 'tax_amount',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'To Pay', 
      value: 'amount',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Markup', 
      value: 'markup_perc',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Value', 
      value: 'markup_value',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Job no.', 
      value: 'code',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Job title', 
      value: 'title',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Phase', 
      value: 'phase',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Kind', 
      value: 'kind',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Description', 
      value: 'description',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'File', 
      value: 'thumbnail',
      type: 'file',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Expense status', 
      value: 'is_used',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
  ],
  finance_receipt_head: [
    {
      text: '',
      value: 'select',
      type: 'option',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Date', 
      value: 'date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Currency', 
      value: 'currency',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Amount', 
      value: 'gross',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'GST', 
      value: 'tax_amount',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'To Pay', 
      value: 'amount',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Markup', 
      value: 'markup_perc',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Value', 
      value: 'markup_value',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Tax Settings', 
      value: 'tax_mode_desc',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Kind', 
      value: 'kind',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Job no.', 
      value: 'code',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Job title', 
      value: 'title',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Phase', 
      value: 'phase',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Description', 
      value: 'description',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'File', 
      value: 'thumbnail',
      type: 'file',
      showable: true,
      searchable: false,
      divider: false,
    },
  ],
  claims_head: [
    {
      text: '',
      value: 'select',
      type: 'option',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim number',
      value: 'number',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Submitted date', 
      value: 'submitted_date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim date', 
      value: 'date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Currency', 
      value: 'currency',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Amount', 
      value: 'gross',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'GST', 
      value: 'tax',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'ToPay', 
      value: 'value',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim description', 
      value: 'desc',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Claim status', 
      value: 'status',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Approval by', 
      value: 'approval_by',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Comments', 
      value: 'remark',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
  ],
  approval_head: [
    {
      text: '',
      value: 'select',
      type: 'option',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim number',
      value: 'number',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Approval status', 
      value: 'status',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Submitted date', 
      value: 'submitted_date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim date', 
      value: 'date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Employee', 
      value: 'supplier',
      type: 'search',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Currency', 
      value: 'currency',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Amount', 
      value: 'gross',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'GST', 
      value: 'tax',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'To Pay', 
      value: 'value',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim description', 
      value: 'desc',
      type: 'search',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Comments', 
      value: 'remark',
      type: 'search',
      showable: true,
      searchable: true,
      divider: false,
    },
  ],
  finance_head: [
    {
      text: '',
      value: 'select',
      type: 'option',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim number',
      value: 'number',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Approval status', 
      value: 'status',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Submitted date', 
      value: 'submitted_date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim date', 
      value: 'date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Employee', 
      value: 'supplier',
      type: 'search',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Approved by', 
      value: 'approval_by',
      type: 'search',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Currency', 
      value: 'currency',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Amount', 
      value: 'gross',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'GST', 
      value: 'tax',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'To Pay', 
      value: 'value',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Claim description', 
      value: 'desc',
      type: 'search',
      showable: true,
      searchable: true,
      divider: false,
    },
  ],
  leave_head: [
    {
      text: 'START DATE', 
      value: 'start_date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'END DATE', 
      value: 'end_date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'TYPE', 
      value: 'type_desc',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'DESCRIPTION', 
      value: 'description',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'DURATION', 
      value: 'duration',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'STATUS', 
      value: 'status_desc',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
  ],
  font_color: '#00AAFD',
  remark_date_flag: ';;',
  server_msge_flag: ';',
  claim_statuses: {
    draft: {
      text: 'Draft',
      value: 0
    },
    pending: {
      text: 'Submitted',
      value: 1
    },
    approved: {
      text: 'Approved',
      value: 2
    },
    rejected: {
      text: 'Rejected',
      value: 3
    },
    posted: {
      text: 'Posted',
      value: 4
    },
    partiallyPaid: {
      text: 'Partially Paid',
      value: 7
    },
    paid: {
      text: 'Paid',
      value: 6
    },
    deleted: {
      text: 'Deleted',
      value: 5
    },
    reversal: {
      text: 'Reversal',
      value: 51
    },
    reversed: {
      text: 'Reversed',
      value: 52
    },
  },
  task_head: [
    {
      text: '',
      value: 'drag',
      type: 'drag',
      showable: false,
      searchable: false,
      divider: false,
    },
    {
      text: '',
      value: 'select',
      type: 'select',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Log time', 
      value: 'log',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Autotime', 
      value: 'auto',
      type: 'text',
      showable: false,
      searchable: false,
      divider: false,
    },
    {
      text: 'Task name', 
      value: 'title',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Job', 
      value: 'display',
      type: 'sort',
      showable: true,
      searchable: true,
      divider: false,
    },
    {
      text: 'Assigned to', 
      value: 'task_for',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Days', 
      value: 'days',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Start date', 
      value: 'start_date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Due date', 
      value: 'end_date',
      type: 'sort',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Status', 
      value: 'status',
      type: 'filter',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Progress', 
      value: 'budget_used',
      type: 'tooltip',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Complete?', 
      value: 'isComplete',
      type: 'tooltip',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Actual(h)', 
      value: 'actual',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Remaining(h)', 
      value: 'remaining',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Budget(h)', 
      value: 'budget',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Priority', 
      value: 'priority',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    },
    {
      text: 'Phase', 
      value: 'phase',
      type: 'text',
      showable: true,
      searchable: false,
      divider: false,
    }
  ],
  tax_settings: [
    { text: 'Tax applies', value: 0 },
    { text: 'Tax free', value: 1 },
    { text: 'Input taxed', value: 2 },
    { text: 'Capital expenditure', value: 3 },
    { text: 'Non reportable', value: 4 },
  ],
  text_color: {
    default: -2147483599,
    kRed: -2147483607,
    kBlack: -2147483618,
    kBlue: -2147483610,
    kCyan: -2147483608,
    kDarkBlue: -2147483617,
    kDarkCyan: -2147483615,
    kDarkGray: -2147483611,
    kDarkGreen: -2147483616,
    kDarkMagenta: -2147483613,
    kDarkRed: -2147483614,
    kDarkYellow: -2147483612,
    kGray: -2147483604,
    kGreen: -2147483609,
    kMagenta: -2147483606,
    kTransparent: 2016,
    kWhite: -2147483603,
    kYellow: -2147483605
  },
  win_name: {
    Menu: 'menu',
    Tasks: 'tasks',
    Timesheets: 'timesheets',
    Dashboard: 'dashboard',
    Expenses: 'expenses',
    Claims: 'claims',
    Manager: 'manager',
    Finance: 'finance',
    WebClaimCreate: 'webclaim',
    WebClaimEdit: 'webclaim',
    DlgTimesheet: 'dlgtimesheet',
    NewTimesheet: 'newtimesheeet',
    MediaPlan: 'mediaplan',
    RadioException: 'radioexception',
    RadioNoHolding: 'radionoholding',
    RadioInvoice: 'radionoinvoice',
    RadioMatches: 'radionomatches',
  },
  create_items: [
    {
      text: 'Timesheet',
      value: 'timesheet',
      key: 0
    },
    {
      text: 'Task',
      value: 'task',
      key: 1
    },
    {
      text: 'Event',
      value: 'event',
      key: 2
    },
    {
      text: 'Leave',
      value: 'leave',
      key: 5
    },
    {
      text: 'Public holiday',
      value: 'holiday',
      key: 4
    },
    {
      text: 'Item',
      value: 'item',
      key: 3
    }
  ],
  date_format: ['D', 'DD', 'DDMM','DM', 'D.M', 'D/M', 'D.M.YY', 'D/M/YY', 'DDMYYYY', 'DDMMYYYY', 'DDMMMYYYY', 'DD MMM YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY']
};

export default global_config;